// src/components/listing/DistanceBadge.js
// Badge d'affichage de la distance - NE PAS MODIFIER

import React from 'react';
import { formatDistance } from '../../utils/distance';

const DistanceBadge = ({ distance }) => {
  if (distance === null || distance === undefined) return null;

  const styles = {
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      color: '#FFFFFF',
      borderRadius: '6px',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: '600',
      whiteSpace: 'nowrap',
      backdropFilter: 'blur(4px)',
    },
    icon: {
      fontSize: '11px',
    },
  };

  return (
    <div style={styles.badge}>
      <span style={styles.icon}>📍</span>
      <span>{formatDistance(distance)}</span>
    </div>
  );
};

export default DistanceBadge;